/* SQSHI theme scripts — drawers, AJAX cart, live search, product form, Peachy, motion */
(function(){
  'use strict';
  const C = window.SQSHI || {};
  const R = C.routes || {};
  const $ = (s, el) => (el || document).querySelector(s);
  const $$ = (s, el) => Array.from((el || document).querySelectorAll(s));
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function money(cents){
    const fmt = C.moneyFormat || '${{amount}}';
    const n = (cents || 0) / 100;
    const group = (v, d, t, s) => { const p = v.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(s); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch(k){
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        default: return group(n, 2, ',', '.');
      }
    });
  }
  const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  /* ---------- drawers / panels ---------- */
  const scrim = $('#scrim');
  let lastFocus = null;
  function openPanel(el){
    if(!el) return;
    lastFocus = document.activeElement;
    $$('.drawer.on,.search-panel.on').forEach(x => { x.classList.remove('on'); x.setAttribute('aria-hidden','true'); });
    el.classList.add('on'); el.setAttribute('aria-hidden','false');
    scrim && scrim.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('input[type=search]') || el.querySelector('.d-close');
    f && setTimeout(() => f.focus(), 250);
  }
  function closePanels(){
    $$('.drawer.on,.search-panel.on').forEach(x => { x.classList.remove('on'); x.setAttribute('aria-hidden','true'); });
    scrim && scrim.classList.remove('on');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  scrim && scrim.addEventListener('click', closePanels);
  document.addEventListener('click', e => {
    if(e.target.closest('[data-close]') || e.target.closest('#searchClose')) { e.preventDefault(); closePanels(); }
    if(e.target.closest('[data-open-menu]')) { e.preventDefault(); openPanel($('#menuDrawer')); }
    if(e.target.closest('[data-open-search]')) { e.preventDefault(); openPanel($('#searchPanel')); }
    if(e.target.closest('[data-open-cart]') && C.cartType !== 'page' && $('#cartDrawer')) { e.preventDefault(); openPanel($('#cartDrawer')); refreshCart(); }
  });
  document.addEventListener('keydown', e => {
    if(e.key === 'Escape') closePanels();
    if(e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName) && $('#searchPanel')) { e.preventDefault(); openPanel($('#searchPanel')); }
  });

  /* ---------- cart ---------- */
  const drawer = $('#cartDrawer');
  function bump(count){
    const cc = $('#cartCount'); if(!cc) return;
    cc.textContent = count; cc.classList.remove('bump'); void cc.offsetWidth; cc.classList.add('bump');
  }
  function renderCart(cart){
    bump(cart.item_count);
    if(!drawer) return;
    const items = $('#dItems'), sub = $('#dSub'), bar = $('#shipBar'), msg = $('#shipMsg');
    sub && (sub.textContent = money(cart.total_price));
    if(bar && msg && C.freeShipping > 0){
      const left = C.freeShipping - cart.total_price;
      bar.style.width = Math.min(100, cart.total_price / C.freeShipping * 100) + '%';
      msg.textContent = left <= 0 ? '✿ You unlocked free shipping!' : `You're ${money(left)} away from free shipping ✿`;
    }
    const cols = ['var(--lilac)','var(--peach)','var(--blue)','var(--butter)','var(--mint)'];
    if(!cart.items.length){
      const tpl = $('#cartEmptyTpl'); items.innerHTML = tpl ? tpl.innerHTML : '';
      $('.d-foot', drawer) && ($('.d-foot', drawer).hidden = true);
      return;
    }
    $('.d-foot', drawer) && ($('.d-foot', drawer).hidden = false);
    items.innerHTML = cart.items.map((it, k) => {
      const img = it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy" width="64" height="64">` : '';
      const variant = it.variant_title && !it.product_has_only_default_variant ? `<small>${esc(it.variant_title)}</small><br>` : '';
      return `<div class="d-item"><a href="${it.url}" class="media" style="background:${cols[k % cols.length]}">${img}</a>
        <div><b>${esc(it.product_title)}</b>${variant}<small>${money(it.final_price)}</small>
          <div class="d-qty"><button type="button" data-line="${k + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-line="${k + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button><button type="button" class="d-rm" data-line="${k + 1}" data-q="0">Remove</button></div></div>
        <div class="d-price">${money(it.final_line_price)}</div></div>`;
    }).join('');
  }
  function refreshCart(){ return fetch((R.cart || '/cart') + '.js', {headers:{Accept:'application/json'}}).then(r => r.json()).then(c => { renderCart(c); return c; }).catch(() => {}); }
  function addToCart(items){
    return fetch((R.cartAdd || '/cart/add') + '.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({items})})
      .then(r => r.json().then(j => { if(!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }))
      .then(() => {
        if(C.cartType === 'page' || !drawer){ window.location.href = R.cart || '/cart'; return; }
        return refreshCart().then(() => openPanel(drawer));
      });
  }
  window.sqAdd = addToCart;
  drawer && drawer.addEventListener('click', e => {
    const b = e.target.closest('button[data-line]'); if(!b) return;
    drawer.classList.add('is-loading');
    fetch((R.cartChange || '/cart/change') + '.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({line: +b.dataset.line, quantity: +b.dataset.q})})
      .then(r => r.json()).then(renderCart).finally(() => drawer.classList.remove('is-loading'));
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-add]'); if(!b) return;
    e.preventDefault(); const t = b.textContent; b.disabled = true;
    addToCart([{id: +b.dataset.add, quantity: 1}]).then(() => { b.textContent = 'Added ♡'; })
      .catch(err => { b.textContent = 'Sold out'; console.warn(err); })
      .finally(() => setTimeout(() => { b.textContent = t; b.disabled = false; }, 1400));
  });
  if(drawer) refreshCart();

  /* ---------- live search ---------- */
  const sInput = $('#searchInput');
  if(sInput){
    const idle = $('#searchIdle'), live = $('#searchLive'), out = $('#searchResults'), count = $('#searchCount'), all = $('#searchAll');
    let timer, ctrl;
    const cols = ['var(--lilac)','var(--peach)','var(--blue)','var(--butter)','var(--mint)'];
    function run(){
      const q = sInput.value.trim();
      idle.hidden = !!q; live.hidden = !q;
      if(!q) return;
      all.href = (R.search || '/search') + '?type=product&q=' + encodeURIComponent(q);
      ctrl && ctrl.abort(); ctrl = new AbortController();
      fetch(`${R.predictiveSearch || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, {signal: ctrl.signal})
        .then(r => r.json()).then(d => {
          const hits = (d.resources && d.resources.results && d.resources.results.products) || [];
          count.textContent = hits.length ? `${hits.length} squish${hits.length === 1 ? '' : 'es'} found` : '';
          const re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
          out.innerHTML = hits.length ? hits.map((p, i) => {
            const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=120" alt="" loading="lazy">` : (p.image ? `<img src="${p.image}" alt="" loading="lazy">` : '');
            const price = p.price_min !== undefined ? p.price_min : p.price;
            const cents = typeof price === 'string' ? Math.round(parseFloat(price) * 100) : +price;
            return `<a class="s-item" href="${p.url}"><div class="media" style="background:${cols[i % cols.length]}">${img}</div><div><b>${esc(p.title).replace(re, '<mark>$1</mark>')}</b><small>${money(cents)}${p.type ? ' · ' + esc(p.type) : ''}</small></div></a>`;
          }).join('') : `<div class="s-none">No squishies match “${esc(q)}” ☁ Try another word!</div>`;
          all.hidden = !hits.length;
        }).catch(() => {});
    }
    sInput.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
    const pops = $('.s-pops');
    pops && pops.addEventListener('click', e => { const b = e.target.closest('button'); if(!b) return; sInput.value = b.textContent; run(); sInput.focus(); });
  }

  /* ---------- account helpers ---------- */
  $$('[data-toggle-recover]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); $('#login-box').hidden = !$('#login-box').hidden; $('#recover-box').hidden = !$('#recover-box').hidden; }));
  if(location.hash === '#recover' && $('#recover-box')){ $('#login-box').hidden = true; $('#recover-box').hidden = false; }
  $$('select[data-default]').forEach(s => { if(s.dataset.default) s.value = s.dataset.default; });

  /* ---------- Peachy: squish in the direction he's tapped ---------- */
  // Tap his top and he flattens down; tap his side and he squishes sideways. The far side stays put, then he springs back.
  (function(){
    if(!Element.prototype.animate){ window.sqPoke = () => {}; return; }
    const SQUASH = 0.66, BULGE = 1.22, directional = C.poke !== false;
    function poke(host, x, y){
      const svg = host.querySelector('svg:not(.huh)'); if(!svg) return;
      svg.getAnimations().forEach(k => k.cancel());
      const body = svg.querySelector('path[fill^="url"]'); if(!body) return;
      const b = body.getBBox(), cx = b.x + b.width / 2, cy = b.y + b.height / 2;
      let dx = 0, dy = -1;
      if(directional && x != null){
        const q = new DOMPoint(x, y).matrixTransform(svg.getScreenCTM().inverse());
        if(Math.hypot((q.x - cx) / b.width, (q.y - cy) / b.height) >= 0.12){ dx = q.x - cx; dy = q.y - cy; }
      }
      const len = Math.hypot(dx, dy), ux = dx / len, uy = dy / len;
      const Rr = 1 / Math.hypot(ux / (b.width / 2), uy / (b.height / 2));
      const vb = svg.viewBox.baseVal, k = svg.clientWidth / vb.width;
      const ox = (cx - ux * Rr - vb.x) * k, oy = (cy - uy * Rr - vb.y) * k;
      const a = Math.atan2(uy, ux) * 180 / Math.PI, t = (sx, sy) => `rotate(${a}deg) scale(${sx},${sy}) rotate(${-a}deg)`;
      svg.style.transformOrigin = `${ox}px ${oy}px`;
      svg.animate([
        {transform: t(1, 1), easing: 'ease-out'},
        {transform: t(SQUASH, BULGE), offset: .18, easing: 'cubic-bezier(.3,1.6,.5,1)'},
        {transform: t(1.08, .95), offset: .5, easing: 'ease-in-out'},
        {transform: t(.97, 1.02), offset: .75, easing: 'ease-out'},
        {transform: t(1, 1)}
      ], {duration: reduceMotion ? 1 : 680});
    }
    window.sqPoke = poke;
  })();

  /* ---------- jelly stretch while scrolling ---------- */
  // Cards & images stretch slightly along the scroll direction and lean a touch, with the leading edge pinned
  // (top when scrolling down, bottom when scrolling up), scaled by scroll speed, then ease back when scrolling stops.
  (function(){
    if(!C.stretch || reduceMotion || !Element.prototype.animate) return;
    const TARGETS = '.card,.cat .ph,.cat .media,.feat,.rev,.hero-art,.news-box,.squishy-toy,.main-img,.thumb,.stats,.bundle';
    const STRETCH = C.stretchAmount || 0.06, LEAN = C.lean != null ? C.lean : 1.2, TOP = 3;
    const fx = new Map();
    function layer(el){
      let a = fx.get(el);
      if(!a){ a = el.animate([{transform:'none'},{transform:'none'}], {duration:1e9, fill:'both', composite:'add'}); a.pause(); fx.set(el, a); }
      return a;
    }
    let lastY = scrollY, lastT = performance.now(), target = 0, cur = 0, running = false;
    function frame(){
      target *= 0.82; cur += (target - cur) * 0.18;
      const m = Math.abs(cur), s = STRETCH * m, k = LEAN * cur, anchor = cur > 0 ? -1 : 1, vh = innerHeight;
      document.querySelectorAll(TARGETS).forEach(el => {
        const r = el.getBoundingClientRect(), on = r.bottom > -50 && r.top < vh + 50;
        if(!on && !fx.has(el)) return;
        let t = 'none';
        if(on && m >= 0.002){
          const d = (anchor * el.offsetHeight / 2).toFixed(2);
          t = `translate(0,${d}px) skewX(${k.toFixed(3)}deg) scale(1,${(1 + s).toFixed(4)}) translate(0,${-d}px)`;
        }
        layer(el).effect.setKeyframes([{transform:t},{transform:t}]);
      });
      if(m < 0.002 && Math.abs(target) < 0.002){ running = false; return; }
      requestAnimationFrame(frame);
    }
    addEventListener('scroll', () => {
      const t = performance.now(), dt = Math.max(8, t - lastT), dy = scrollY - lastY; lastY = scrollY; lastT = t;
      const v = Math.max(-1, Math.min(1, (dy / dt) / TOP));
      target = Math.abs(v) > Math.abs(target) ? v : target * .5 + v * .5;
      if(!running){ running = true; requestAnimationFrame(frame); }
    }, {passive:true});
  })();

  /* ---------- per-section behaviour (re-run when the theme editor reloads a section) ---------- */
  function init(root){
  /* cart page quantity buttons */
  $$('[data-cart-qty]', root).forEach(b => b.addEventListener('click', () => {
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(0, (+input.value || 0) + (+b.dataset.cartQty));
    const f = b.closest('form'); const u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; f.appendChild(u); f.submit();
  }));

  /* ---------- collection sort ---------- */
  $$('[data-sort]', root).forEach(s => s.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
  }));

  /* ---------- product page ---------- */
  $$('[data-product-section]', root).forEach(sec => {
    const json = $('[data-product-json]', sec); if(!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('[data-product-form]', sec), idInput = $('[data-variant-id]', sec), btn = $('[data-add-btn]', sec), priceEl = $('[data-price]', sec), msg = $('[data-form-msg]', sec);
    const label = btn ? (btn.dataset.label || 'Add to cart') : 'Add to cart';
    const qtyInput = $('[data-qty-input]', sec), bundle = $('[data-bundle]', sec);
    let variant = product.variants.find(v => idInput && v.id == idInput.value) || product.variants[0];

    const strip = $('[data-thumbs]', sec), thumbs = $$('[data-thumb]', sec);
    function keepInView(t){
      if(!strip || !t) return;
      const s = strip.getBoundingClientRect(), r = t.getBoundingClientRect(), pad = 8;
      if(r.left < s.left + pad) strip.scrollBy({ left: r.left - s.left - pad });
      else if(r.right > s.right - pad) strip.scrollBy({ left: r.right - s.right + pad });
    }
    function showMedia(id){
      if(!id) return;
      $$('[data-media]', sec).forEach(m => m.classList.toggle('on', m.dataset.media == id));
      thumbs.forEach(t => { const on = t.dataset.thumb == id; t.classList.toggle('active', on); on && keepInView(t); });
    }
    function step(d){
      if(thumbs.length < 2) return;
      const i = thumbs.findIndex(t => t.classList.contains('active'));
      showMedia(thumbs[(i + d + thumbs.length) % thumbs.length].dataset.thumb);
    }
    $$('[data-step]', sec).forEach(b => b.addEventListener('click', () => step(+b.dataset.step)));
    const stage = $('.main-img', sec); let x0 = null;
    stage && stage.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    stage && stage.addEventListener('touchend', e => { if(x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if(Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); });
    function updateButton(){
      if(!btn) return;
      const q = Math.max(1, +(qtyInput && qtyInput.value) || 1);
      const extra = bundle && bundle.checked ? +bundle.dataset.bundlePrice : 0;
      if(!variant){ btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? `${label} · ${money(variant.price * q + extra)}` : 'Sold out';
    }
    function selectVariant(){
      const chosen = $$('[data-opt]:checked', sec).map(i => i.value);
      variant = product.variants.find(v => v.options.every((o, i) => o === chosen[i]));
      chosen.forEach((v, i) => { const l = $(`[data-opt-label="${i}"]`, sec); l && (l.textContent = v); });
      if(variant){
        idInput && (idInput.value = variant.id);
        priceEl && (priceEl.innerHTML = money(variant.price) + (variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : ''));
        variant.featured_media && showMedia(variant.featured_media.id);
        const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u.toString());
      }
      // grey out values that can't be bought with the other current choices
      $$('[data-opt]', sec).forEach(inp => {
        const i = +inp.dataset.opt, test = chosen.slice(); test[i] = inp.value;
        const ok = product.variants.some(v => v.available && v.options.every((o, j) => o === test[j]));
        inp.classList.toggle('unavailable', !ok);
      });
      updateButton();
    }
    $$('[data-opt]', sec).forEach(i => i.addEventListener('change', selectVariant));
    $$('[data-thumb]', sec).forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumb)));
    $$('[data-qty]', sec).forEach(b => b.addEventListener('click', () => { qtyInput.value = Math.max(1, (+qtyInput.value || 1) + (+b.dataset.qty)); updateButton(); }));
    qtyInput && qtyInput.addEventListener('input', updateButton);
    bundle && bundle.addEventListener('change', updateButton);
    if($$('[data-opt]', sec).length) selectVariant(); else updateButton();

    form && form.addEventListener('submit', e => {
      if(!variant || !window.fetch) return;
      e.preventDefault();
      msg && (msg.hidden = true);
      const items = [{id: variant.id, quantity: Math.max(1, +qtyInput.value || 1)}];
      if(bundle && bundle.checked) items.push({id: +bundle.dataset.bundle, quantity: 1});
      btn.classList.add('is-loading');
      addToCart(items).then(() => { btn.textContent = 'Added ♡'; setTimeout(updateButton, 1300); })
        .catch(err => { if(msg){ msg.textContent = err.message; msg.hidden = false; } })
        .finally(() => btn.classList.remove('is-loading'));
    });

    /* squish stat meters fill when they scroll into view */
    const stats = $('.stats', sec);
    if(stats){
      const fill = () => $$('.meter i', stats).forEach(i => i.style.width = i.dataset.w + '%');
      if('IntersectionObserver' in window){ const io = new IntersectionObserver(es => es.forEach(en => { if(en.isIntersecting){ fill(); io.disconnect(); } }), {threshold:.3}); io.observe(stats); } else fill();
    }
  });

  /* ---------- Peachy: squish counter ---------- */
  $$('[data-squish-counter]', root).forEach(p => {
    const out = document.getElementById('squishCount-' + p.dataset.squishCounter); if(!out) return;
    let n = 0; const extra = out.dataset.milestone || '', extra100 = out.dataset.bigMilestone || '';
    const tick = () => { n++; out.textContent = `${n} squish${n === 1 ? '' : 'es'} so far${n >= 100 && extra100 ? extra100 : n >= 10 ? extra : ''}`; };
    p.addEventListener('click', tick);
    p.addEventListener('keydown', e => { if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); tick(); } });
  });

    $$('.squishy-toy[role="button"],.mini-peachy[role="button"]', root).forEach(h => {
      h.addEventListener('pointerdown', e => window.sqPoke(h, e.clientX, e.clientY));
      h.addEventListener('keydown', e => { if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); window.sqPoke(h); } });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
